<template>
	<div class="category-selector">
		<select
			class="select category-selector__select"
			v-model="category1Model"
			:disabled="disabled"
			@keydown.enter="$emit('enter')"
		>
			<option
				v-for="(item, idx) in category1List"
				:key="item.id"
				:value="item.id"
			>
				{{
					item.isDisplay || idx === 0
						? item.value
						: `[미노출] ${item.value}`
				}}
			</option>
		</select>

		<select
			v-if="category_level >= 2"
			class="select category-selector__select"
			v-model="category2Model"
			:disabled="disabled"
			@keydown.enter="$emit('enter')"
		>
			<option
				v-for="(item, idx) in category2List"
				:key="item.id"
				:value="item.id"
			>
				{{
					item.isDisplay || idx === 0
						? item.value
						: `[미노출] ${item.value}`
				}}
			</option>
		</select>

		<select
			v-if="category_level >= 3"
			class="select category-selector__select"
			v-model="category3Model"
			:disabled="disabled"
			@keydown.enter="$emit('enter')"
		>
			<option
				v-for="(item, idx) in category3List"
				:key="item.id"
				:value="item.id"
			>
				{{
					item.isDisplay || idx === 0
						? item.value
						: `[미노출] ${item.value}`
				}}
			</option>
		</select>
	</div>
</template>

<script>
	export default {
		name: 'CategorySelector',
		props: {
			disabled: { default: false },
			wrapWidth: { default: 100, type: Number },
			wrapWidthUnit: { default: '%', type: String },
			selectClass: { type: String },
			category_level: { type: Number, default: 3 },
			award: { default: false },
			reset: { default: false },
		},
		data() {
			return {
				noInitList: false,
				category1List: [
					{ id: null, value: '1차 카테고리 선택', hasChild: true },
				],
				category2List: [
					{ id: null, value: '2차 카테고리 선택', hasChild: true },
				],
				category3List: [
					{ id: null, value: '3차 카테고리 선택', hasChild: false },
				],
				category1: null,
				category2: null,
				category3: null,
				keywordList: [],
				nextCategoryDepth: 1,
			};
		},
		computed: {
			wrapStyle() {
				return { width: `${this.wrapWidth}${this.wrapWidthUnit}` };
			},
			category1Model: {
				get() {
					return this.category1;
				},
				async set(category1) {
					await this.categoryChange({
						level: 1,
						idParentCategory: category1,
						category1,
						category2: null,
						category3: null,
					});
				},
			},
			category2Model: {
				get() {
					return this.category2;
				},
				async set(category2) {
					await this.categoryChange({
						level: 2,
						idParentCategory: category2,
						category1: this.category1,
						category2,
						category3: null,
					});
				},
			},
			category3Model: {
				get() {
					return this.category3;
				},
				async set(category3) {
					await this.categoryChange({
						level: 3,
						idParentCategory: category3,
						category1: this.category1,
						category2: this.category2,
						category3,
					});
				},
			},
		},
		watch: {
			reset() {
				this.init();
			},
		},
		methods: {
			async init() {
				this.category1 = this.category2 = this.category3 = null;
				await this.categoryChange({
					level: 1,
					idParentCategory: null,
					category1: null,
					category2: null,
					category3: null,
				});
			},
			async getCategoryList(level, idParentCategory) {
				try {
					const keys = ['First', 'Second', 'Third'];
					const currKey = keys[level - 1];
					const params = {};
					let parsedList = [];
					let nextCategoryDepth = null;
					if (typeof idParentCategory !== 'number') {
						nextCategoryDepth = level - 1;
					}
					if (level === 1 || typeof idParentCategory === 'number') {
						params.idParentCategory = idParentCategory;
						const { data } = await this.$axiosAdmin2.get(
							`/api/categories/level/${level}`,
							{ params }
						);
						if (data.data.length > 0) {
							nextCategoryDepth = level;
							parsedList = data.data.map(item => {
								return {
									id: item[`id${currKey}Category`],
									value: item[
										`${currKey.toLowerCase()}CategoryText`
									],
									hasChild: (() => {
										if (level === 1) return true;
										if (level === 2) return item.hasChild;
										if (level === 3) return false;
									})(),
									isDisplay: item.isDisplay,
								};
							});
						}
					}
					if (level <= 2 && !this.noInitList) {
						this[`category3List`] = [
							{
								id: null,
								value: '3차 카테고리 선택',
								hasChild: false,
							},
						];
					}
					parsedList.unshift({
						id: null,
						value: `${level}차 카테고리 선택`,
						hasChild: level !== 3,
					});
					this[`category${level}List`] = parsedList;
					return nextCategoryDepth;
				} catch (err) {
					console.error(err);
					alert(
						'카테고리 불러오기에 실패했습니다. 개발팀에 문의 하세요.'
					);
				}
			},

			async categoryChange({
				level,
				idParentCategory,
				category1,
				category2,
				category3,
			}) {
				const nextCategoryDepth = (this.nextCategoryDepth =
					await this.getCategoryList(level + 1, idParentCategory));
				this.category1 = category1;
				this.category2 = category2;
				this.category3 = category3;
				let c1,
					c2,
					c3 = null;
				if (category1) {
					c1 = _.find(this.category1List, { id: category1 });
				}
				if (category2) {
					c2 = _.find(this.category2List, { id: category2 });
				}
				if (category3) {
					c3 = _.find(this.category1List, { id: category3 });
				}
				if (this.award && category3) {
					c3 = _.find(this.category3List, { id: category3 });
				}
				this.$emit('change', {
					category1,
					category2,
					category3,
					c1,
					c2,
					c3,
				});
			},

			async setCategory(args) {
				this.noInitList = true;
				try {
					const category1 = args.category1;
					const category2 = args.category2;
					const category3 = args.category3;
					let level = 1;
					let idCategory = category1;
					await this.getCategoryList(1);
					let nextCategoryDepth = await this.getCategoryList(
						2,
						category1
					);
					this.category1 = category1;

					if (this.category1 === null) {
						this.category2 = null;
					}

					if (category2) {
						level = 2;
						idCategory = category2;
						nextCategoryDepth = await this.getCategoryList(
							3,
							category2
						);
						this.category2 = category2;
					}
					if (category3) {
						level = 3;
						idCategory = category3;
						this.category3 = category3;
						nextCategoryDepth = null;
					}
					this.$emit('change', { category1, category2, category3 });
				} catch (err) {
					this.noInitList = false;
					console.error(err);
					alert(
						'카테고리 데이터를 바인딩하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
				this.noInitList = false;
			},
		},
		created() {
			this.getCategoryList(1);
		},
		mounted() {
			this.$nextTick(() => {
				this.$emit('mounted');
			});
		},
	};
</script>

<style lang="scss" scoped>
	.category-selector {
		display: flex;

		.category-selector__select {
			display: block;
			height: 28px;
			margin-left: 1px;
			background: white;
			border: solid 1px #dfe6ee;
			border-radius: 4px;
			font-size: 0.875rem;

			&:first-child {
				margin-left: 0;
			}

			&:focus {
				outline: 1px solid #0099fa;
			}
		}
	}
</style>
